import { useLayoutStore } from "./pinia/layout";
import { useAuthStore } from "./pinia/auth";
import { createPinia } from "pinia";
import { useUserStore } from "./pinia/user";
import { useRolesStore } from "./pinia/role";
import { useCategoryStore } from "./pinia/category";
import { useTagStore } from "./pinia/tag";
import { useArticleStore } from "./pinia/article";
import { useEmailStore } from "./pinia/email";

const pinia = createPinia();
export default pinia;

export { useLayoutStore, useAuthStore, useUserStore, useRolesStore, useCategoryStore, useTagStore, useArticleStore, useEmailStore };
